import { ApiConfig } from "../../config";
import { DocumentDataType, Document } from "../../models";
import { AppStateWithData } from "../../redux";
import { getRequestHeaders, getToken } from "../../utils";

interface SearchRequest {
    query: string
    page: number
    size: number
    dataTypes?: DocumentDataType[]
    isAuthor?: boolean
    sortField?: string
    AggType?: 'FLAT',
    filter?: any,
    itemsIds?: string[]
    excludeIds?: string[]
}

interface SearchResult {
    Value: {
        Source: Document
    }
}

interface SearchResponse {
    data: SearchResult[]
}

let searchDocumentsAbortController: AbortController | null = null
let searchDocumentsAbortSignal: AbortSignal | null = null

export const searchDocumentsWithAbort = (config: ApiConfig, state: AppStateWithData) => async (request: SearchRequest, urlPostfix?: string): Promise<Document[] | null> => {
    const token = getToken(state)
    if (!token) {
        throw 'No token'
    }

    try {
        if (searchDocumentsAbortController !== null) {
            searchDocumentsAbortController.abort()
        }

        const browserSupportsAbortion = "AbortController" in window
        if (browserSupportsAbortion) {
            searchDocumentsAbortController = new AbortController()
            searchDocumentsAbortSignal = searchDocumentsAbortController.signal
        }


        const headers = getRequestHeaders(token, true)

        const response = await fetch(`${config.API_URL}/search${!urlPostfix ? '' : urlPostfix}`, {
            signal: searchDocumentsAbortSignal,
            method: 'POST',
            body: JSON.stringify(request),
            headers
        })

        const result = await response.json() as SearchResponse
        return result.data.map(x => x.Value.Source)

    } catch (e) {
        return null
    }
}

export const searchDocumentsWithoutAbort = (config: ApiConfig, state: AppStateWithData) => async (request: SearchRequest, urlPostfix?: string): Promise<Document[] | null> => {
    const token = getToken(state)
    if (!token) {
        throw 'No token'
    }

    try {
        const headers = getRequestHeaders(token, true)

        const response = await fetch(`${config.API_URL}/search${!urlPostfix ? '' : urlPostfix}`, {
            method: 'POST',
            body: JSON.stringify(request),
            headers
        })

        const result = await response.json() as SearchResponse
        return result.data.map(x => x.Value.Source)

    } catch (e) {
        return null
    }
}